import { Box } from '@chakra-ui/react';
import { Text, Colors } from '@mercator-gcp/grout';
import { SortingIcon } from 'components/elements/SortingIcon';
import { FlexRow } from 'components/layout/FlexRow';

const clickableHeaderStyle = { cursor: 'pointer', display: 'inline-flex' };

type TSortableHeaderProp = {
  headingKey: string;
  label: string;
  currentHeading: string;
  isSorted: boolean;
  onClick: () => void;
};

const SortableHeader = ({
  headingKey,
  label,
  currentHeading,
  isSorted,
  onClick,
}: TSortableHeaderProp) => (
  <Box onClick={onClick} sx={clickableHeaderStyle}>
    <FlexRow>
      <Text.SmallLabel
        sx={{ paddingRight: 'padding_8' }}
        color={
          isSorted && headingKey === currentHeading
            ? Colors.ArmyGreen900
            : Colors.ArmyGreen500
        }
      >
        {label}
      </Text.SmallLabel>
      <SortingIcon
        selectedHeading={headingKey}
        currentHeading={currentHeading}
        isSorted={isSorted}
      />
    </FlexRow>
  </Box>
);

export default SortableHeader;
